export default "__VITE_ASSET__K4c1rwvR__"